<template>
  <div>
    <v-layout justify-space-between class="color--blue mt-4 mb-0">
      <v-flex class="d-flex align-center">
        <img class="icon" src="@/assets/images/icons/earlypay/deposit.svg" />
        오늘 입금액
      </v-flex>
      <v-flex class="text-right">
        {{ $filters.commaFormat(sumByPropertyName(data.paymentsDetail, 'depositAmount')-data.repaymentsSum) }} 원
      </v-flex>
    </v-layout>
    <v-layout justify-end class="mt-0">
      <v-btn
        x-small
        outlined
        color="grey darken-1"
        class="account-button"
        @click="goToAccount"
      >
        계좌 정보
      </v-btn>
    </v-layout>

    <v-layout justify-space-between class="color--orange">
      <v-flex class="d-flex align-center" style="word-spacing: -0.5px">
        <img class="icon" src="@/assets/images/icons/earlypay/sales.svg" />
        정산 대상 매출
      </v-flex>
      <v-flex class="d-flex align-center justify-end">
        <span class="amount">{{ $filters.commaFormat(data.settlementTargetSalesAmount) }} 원</span>
      </v-flex>
    </v-layout>

    <v-layout justify-space-between class="color--nice-grey">
      <v-flex class="d-flex align-center">
        <img class="icon" src="@/assets/images/icons/earlypay/fee.svg" />
        공제 합
        <span class="font-size--12 align-self-end">&nbsp;(수수료+기타)</span>
      </v-flex>
      <v-flex class="text-right"> {{ $filters.commaFormat(data.totalDeductionAmount) }} 원 </v-flex>
    </v-layout>
    <v-layout justify-space-between class="color--nice-grey" v-if="data.repaymentsSum">
      <v-flex class="d-flex align-center">
        <img class="icon" src="@/assets/images/icons/earlypay/fee.svg" />
        대출 상환
      </v-flex>
      <v-flex class="text-right"> -{{ $filters.commaFormat(data.repaymentsSum) }} 원 </v-flex>
    </v-layout>
    <p>타밴 매출이 있는 경우, 오후 5시 반영됩니다.</p>
  </div>
</template>

<script>
import { sumByPropertyName } from '@/util/mathUtil'

export default {
  props: ['data'],
  methods: {
    // 리스트 아이템 목록의 합계 표시용
    sumByPropertyName,
    goToAccount() {
      this.$router.push('/bank/withdrawal-info')
    }
  },
}
</script>

<style lang="scss" scoped>
p {
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 12px;
  text-align: center;
}

.account-button {
  font-size: 11px !important;
  height: 22px !important;
  padding: 0 8px !important;
  text-transform: none !important;
  letter-spacing: -0.3px;
  border-radius: 4px !important;
}
</style>
